import api from './api';
import filesApi from './files';

export default {
    async getFolders(params, token) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`
            };
            const response = await api.get(`/folders/`, {
                headers,
                params,
            });
            return response;
        } catch (error) {
            console.error('Erro ao fazer listagem de pastas:', error);
                throw error;
        }
    },
    async getFileById(id, token) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`
            };
            const response = await api.get(`/files/${id}`, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao fazer listagem do arquivo:', error);
                throw error;
        }
    },
    async createFolder(params, token) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`
            };
            const response = await api.post('/folders', params, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao criar pasta:', error);
                throw error;
        }
    },
    /** @deprecated Preferir files.moveFileToFolder / files.moveFiles */
    async moveFileToFolder(token, payloadOrFileId, targetFolderId) {
        if (typeof payloadOrFileId === 'object' && payloadOrFileId !== null) {
            const fileIds =
                payloadOrFileId.fileIds ||
                (payloadOrFileId.fileId ? [payloadOrFileId.fileId] : []);
            const folder =
                payloadOrFileId.targetFolderId ?? payloadOrFileId.folderId;
            return filesApi.moveFiles(token, { fileIds, targetFolderId: folder });
        }
        return filesApi.moveFileToFolder(token, payloadOrFileId, targetFolderId);
    },
    async editFolder(id, payload, token) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`
            };
            const response = await api.put(`/folders/${id}`, payload, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao editar pasta:', error);
                throw error;
        }
    },
    async deleteFolder(id, token) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`
            };
            const response = await api.delete(`/folders/${id}`, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao deletar pasta:', error);
                throw error;
        }
    },
}

